import React, { useState, useEffect, useCallback, useMemo } from "react";
import { baseUrl } from "../../../../../../../../../../network/constants/constants";
import { getConfig } from "../../../../../../../../../../network/auth";
import axios from "../../../../../../../../../../network/api";
import "./serviceMain.css";
import { Container } from "react-bootstrap";
import ServiceDetailsPage from "./serviceDetailPage/serviceDetailsPage";
import ServiceTable from "./serviceTable/serviceTable";
import ServiceAddEditForm from "./serviceAddEditForm/serviceAddEditForm";
import ServiceImportForm from "./serviceImportForm/serviceImportForm";
import { Alert, Snackbar } from "@mui/material";

const ServiceMain = ({ franchiseId }) => {
  const [categoryList, setCategoryList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [franchiseList, setFranchiseList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [serviceId, setServiceId] = useState(null);

  const [ImportOpen, setImportOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);

  const [selectedService, setSelectedService] = useState(null);

  const [selectedServiceDatas, setSelectedServiceDatas] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [selectedServiceList, setSelectedServiceList] = useState([]);
  const [categoryIdImport, setCategoryImport] = useState("");

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchCategory = () => {
    setLoading(true);
    axios
      .get(
        baseUrl + `superadmin/category-list-by-business-id/${franchiseId}/`,
        config
      )
      .then((response) => {
        setLoading(false);
        setCategoryList(response.data);
      })
      .catch((error) => {
        console.error("Category Error:", error);
        setLoading(false);
      });
  };

  const fetchServices = useCallback((categoryId) => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/services-by-category/${categoryId}/`, config)
      .then((response) => {
        setLoading(false);
        setServiceList(response.data);
      })
      .catch((error) => {
        console.error("Service Error:", error);
        setLoading(false);
      });
  }, []);

  const fetchFranchise = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/business/`, config)
      .then((response) => {
        const result = response.data.map(({ id, business_title }) => ({
          id,
          business_title,
        }));
        setFranchiseList(result);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Franchise Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCategory();
    fetchFranchise();
  }, []);

  const handleSelectService = (service) => {
    setSelectedService(service);
    setSelectedServiceDatas(service);
  };

  const handleSelectServiceId = (id) => {
    setServiceId(id);
  };

  const handleGoBack = () => {
    setSelectedService(null);
  };

  const handleImportForm = () => {
    setImportOpen(true);
  };

  const handleImportCloseForm = () => {
    setImportOpen(false);
  };

  const handleAddForm = () => {
    setAddOpen(true);
  };

  const handleEditClick = (service = null) => {
    setIsEdit(true);
    setSelectedServiceDatas(service);
    setAddOpen(true);
  };

  const handleAddCloseForm = () => {
    setIsEdit(false);
    setAddOpen(false);
  };

  const deleteService = (serviceId, categoryId) => {
    setLoading(true);

    axios
      .delete(`${baseUrl}app/service/delete/${serviceId}/`, config)
      .then((response) => {
        setServiceList((prevList) =>
          prevList.filter((service) => service.id !== serviceId)
        );
        setSnackbar({
          open: true,
          message: "The service has been deleted",
          severity: "success",
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting service:", error);
        setLoading(false);
        setSnackbar({
          open: true,
          message: "Something went wrong. Please try again",
          severity: "error",
        });
      });
  };

  const handleSubmit = (newService) => {
    
    setLoading(true);
    const formData = new FormData();

    formData.append("business", franchiseId);
    formData.append("category", newService.category);
    formData.append("service", newService.service);
    formData.append("description", newService.description);
    formData.append("open_time", newService.open_time);
    formData.append("close_time", newService.close_time);
    formData.append("terms_and_condition", newService.terms_and_condition);

    if (newService.thumb && newService.thumb instanceof File) {
      formData.append("thumb", newService.thumb);
    }
    
    formData.append("features", JSON.stringify(newService.features));
    formData.append("price_chart", JSON.stringify(newService.price_chart));
    if (isEdit) {
      editData(formData);
    } else {
      submitData(formData);
    }
    
  };
  const submitData = (formData) => {
    axios
      .post(`${baseUrl}superadmin/services/create/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        fetchServices(formData.get("category"));
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error adding data:", error);
      });
  };

  const editData = (formData) => {
    const id = selectedServiceDatas?.row?.id;

    axios
      .put(`${baseUrl}superadmin/services/edit/${id}/`, formData, {
        headers: {
          ...config.headers,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        fetchServices(formData.get("category"));
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error adding data:", error);
      });
  };

  const handleServiceImportSubmit = () => {
    
    setLoading(true);
    const postData = {
      category_id: categoryIdImport,
      service_id: selectedServiceList
    };
  

    axios
      .post(`${baseUrl}superadmin/template-service-import/${franchiseId}/`,  postData, config)
      .then((response) => {
        setLoading(false);
        setSnackbar({
          open: true,
          message: "Services imported successfully!",
          severity: "success",
        });
        fetchServices(categoryIdImport);
      })
      .catch((error) => {
        console.error("Error: ", error);
        setLoading(false);
      });
  };


  return (
    <Container className="mt-3 service-main" fluid>
      <button className="btn-import-service" onClick={handleImportForm}>
        Import Service
      </button>
      <button className="btn-add-service" onClick={handleAddForm}>
        + Add Service
      </button>
      {selectedService ? (
        <ServiceDetailsPage
          service={selectedService}
          onGoBack={handleGoBack}
          serviceList={serviceList}
          serviceId={serviceId}
        />
      ) : (
        <ServiceTable
          categoryList={categoryList}
          serviceList={serviceList}
          fetchServices={fetchServices}
          setServiceList={setServiceList}
          onSelectService={handleSelectService}
          onSelectServiceId={handleSelectServiceId}
          onServiceFormEdit={handleEditClick}
          onDelete={deleteService}
          setCategoryImport={setCategoryImport}
        />
      )}
      <ServiceAddEditForm
        open={addOpen}
        onClose={handleAddCloseForm}
        serviceData={isEdit ? selectedServiceDatas?.row : null}
        categoryList={categoryList}
        onSubmit={handleSubmit}
      />

      <ServiceImportForm
        open={ImportOpen}
        onClose={handleImportCloseForm}
        franchiseId={franchiseId}
        fetchCategory={fetchCategory}
        fetchServices={fetchServices}
        franchiseList={franchiseList}
        setLoading={setLoading}
        selectedServiceList={selectedServiceList}
        setSelectedServiceList={setSelectedServiceList}
        onSubmit={handleServiceImportSubmit}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ServiceMain;
